// extracted by mini-css-extract-plugin
export default {"AssessmentWho":"AssessmentWho_AssessmentWho__7ZRsx","title":"AssessmentWho_title__lO5s9","text":"AssessmentWho_text__8hvLK"};